import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-movedown-button-sm',
  templateUrl: './movedown-button-sm.component.html',
  styleUrls: ['./movedown-button-sm.component.scss']
})
export class MoveDownButtonSmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
